import React, { useCallback, useState, useEffect } from 'react';
import styled from 'styled-components';
import { useForm } from 'react-hook-form';

import FormField from '@components/FormField';
import Button from '@core/Button';
import Link from '@core/Link';

import { fontM } from '@fonts';
import mq from '@mq';

import scrollTo from '@utils/scrollTo';

const EventForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
  });

  const [success, setSuccess] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const onSubmit = useCallback(formData => {
    const payload = {
      ...formData,
      'form-name': 'events',
    };

    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(payload).toString(),
    })
      .then(() => {
        setSubmitted(true);
        setSuccess(true);
        scrollTo('#events-form-title');
      })
      .catch(() => {
        setSubmitted(true);
        setSuccess(false);
      });
  }, []);

  return (
    <Container>
      {!submitted && (
        <FormElement
          onSubmit={handleSubmit(onSubmit)}
          name="events"
          method="POST"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          noValidate
        >
          <Body>
            <FormField
              name="name"
              label="Name"
              register={register}
              errors={errors}
              config={{
                required: true,
                maxLength: 100,
              }}
            />
            <FormField
              name="email"
              label="Email Adresse"
              register={register}
              errors={errors}
              config={{
                required: true,
                pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i,
              }}
            />
            <FormField
              name="telephone"
              label="Telefon"
              type="tel"
              register={register}
              errors={errors}
              config={{
                required: true,
              }}
            />
            <FormField name="firma" type="text" label="Firma" register={register} errors={errors} />
            <FormField
              name="date"
              type="text"
              label="Datum des Events"
              register={register}
              errors={errors}
            />
            <FormField
              name="guests"
              type="text"
              label="Anzahl der Gäste"
              register={register}
              errors={errors}
            />
            <FormField
              name="occasion"
              type="textarea"
              label="Anlass"
              register={register}
              errors={errors}
            />
            <FormField
              name="remarks"
              type="textarea"
              label="Anmerkungen"
              register={register}
              errors={errors}
            />
            <input type="hidden" name="form-name" value="events" />
            <Submit>
              <SubmitButton disabled={!isValid} type="submit">
                Absenden
              </SubmitButton>
              <div>
                lies unsere <Link to="/datenschutzerklaerung">Datenschutzerklärung</Link>
              </div>
            </Submit>
          </Body>
        </FormElement>
      )}
      {submitted && success && (
        <Message>
          Vielen Dank,
          <br />
          wir melden uns schnellstmöglich
        </Message>
      )}
      {submitted && !success && (
        <Message>
          Es tut uns leid, irgendetwas ist schief gegangen.
          <br />
          Bitte probiere es später noch einmal.
        </Message>
      )}
    </Container>
  );
};

const Container = styled.div``;

const FormElement = styled.form`
  margin-top: 1.5rem;
`;

const Body = styled.div`
  display: grid;
  row-gap: 3rem;
`;

const SubmitButton = styled(Button)`
  margin-top: -0.5rem;

  ${mq.small} {
    justify-self: center;
  }
`;

const Submit = styled.div`
  display: grid;
  row-gap: 0.75rem;
  justify-content: center;
  text-align: center;
  margin-top: 2rem;
`;

const Message = styled.div`
  ${fontM};

  margin-top: 5rem;

  ${mq.small} {
    text-align: center;
  }
`;

export default EventForm;
